import React from 'react'
import { WithContext as ReactTags } from 'react-tag-input'
import '../css/tagbox.css'

export default class TagBox extends React.Component {
  constructor(props) {
    super(props)
    const suggestionList = [
      '720p',
      '1080p',
      'hdlight',
      'multi',
      'truefrench',
      'bdrip',
      'brrip',
      'bluray',
      'dvdrip',
      'vostfr',
      'french',
      'vff',
      'discography',
      'flac',
      'ogg',
      'mp3',
    ]
    this.state = {
      tags: [],
      suggestions: suggestionList.map((text, index) => ({ id: text, text })),
    }
  }

  handleDelete(i) {
    let tags = this.state.tags
    tags.splice(i, 1)
    this.setState({tags: tags})
    this.props.notifyParent(this.state.tags)
  }

  handleAddition(tag) {
    let tags = this.state.tags
    // In v6, tag is already an object with id and text
    const newTag = typeof tag === 'string'
      ? { id: tag, text: tag }
      : { id: tag.text || tag.id, text: tag.text || tag.id }
    tags.push(newTag)
    this.setState({tags: tags})
    this.props.notifyParent(this.state.tags)
  }

  handleDrag(tag, currPos, newPos) {
    let tags = this.state.tags

    // mutate array
    tags.splice(currPos, 1)
    tags.splice(newPos, 0, tag)

    // re-render
    this.setState({ tags: tags })
    this.props.notifyParent(this.state.tags)
  }

  render() {
    let tags = this.state.tags
    let suggestions = this.state.suggestions
    return (
      <ReactTags classNames={{tagInputField: 'form-control'}}
                    tags={tags}
                    suggestions={suggestions}
                    handleDelete={this.handleDelete.bind(this)}
                    handleAddition={this.handleAddition.bind(this)}
                    handleDrag={this.handleDrag.bind(this)}
      />
    )
  }
}
